$eve_radio $eve_button
	disabled? null
	colors? \primary
	justify_content \center
	align_items \center
	size null
	attr *
		^
		mol_check_checked <= checked? false
		aria-checked <= aria_checked \false
		role <= aria_role \radio
	event *
		^
		click?event <=> event_click?event null
	sub /
		<= Input $mol_view
			dom_name \input
			attr *
				type \radio
				id <= dom_id \
				name <= name \
				value <= value \
				checked <= input_checked? false
				tabindex \-1
		<= Disc $eve_surface
			colors? \primary

